import { render, staticRenderFns } from "./CarrouselParceiros.vue?vue&type=template&id=51faced8&scoped=true"
import script from "./CarrouselParceiros.vue?vue&type=script&lang=js"
export * from "./CarrouselParceiros.vue?vue&type=script&lang=js"
import style0 from "./CarrouselParceiros.vue?vue&type=style&index=0&id=51faced8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51faced8",
  null
  
)

export default component.exports